import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useGlobalContext } from "context/GlobalContext";

export const Modal = () => {
  const gContext = useGlobalContext();

  return (
    <div>
      <Dialog
        open={gContext.isShowModal}
        onClose={() => gContext.toggleModal(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{gContext.currentDataModal?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {gContext.currentDataModal?.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {gContext.currentDataModal?.cancelText && (
            <Button
              onClick={gContext.currentDataModal?.onCancel}
              color="primary"
            >
              {gContext.currentDataModal?.cancelText || "Cancelar"}
            </Button>
          )}
          <Button
            onClick={gContext.currentDataModal?.onOk}
            color="primary"
            autoFocus
          >
            {gContext.currentDataModal?.okText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
